import { useQuery } from '@tanstack/react-query'
import { streamApi } from '../api'

const getFeedToken = async (id: string) => {
  const result = await streamApi.post(
    '/getToken',
    { id: id || 'anonymous' },
  )

  return result.token || ''
}

export default function useFeedToken(id: string) {
  return useQuery({
    queryKey: ['feedToken', id],
    queryFn: () => getFeedToken(id),
    // enabled: isAuth,
    staleTime: 60000,
  })
}
